import Component from "../component.abstract";
import CvUploaderService from "@services/cv-uploader-service";
import {getSingleInstanceByName, initialiseComponents} from "../../core";

interface CvUploaderProps {
    required: string,
    msg: Msg,
    button: Button,
    maxsize: number,
    extension: string,
    url: string,
    uploaderKey: string,
    uploaderType: string,
    uploaderApp: string
}

interface Msg {
    required: string,
    maxsize: string,
    extension: string
}

interface Button {
    addCv: string,
    download: string,
    editCv: string,
    useCv: string
}

interface Labels {
    addCv: string;
    download: string;
    editCv: string;
    errorServer: string;
    errorUpload: string;
    errorFileMarvin: string;
    msgMaxsize: string;
    msgExtension: string;
    msgRequiredCv: string;
    useCv: string;
}

export default class CvUploader extends Component {

    public labels: Labels = {
        "addCv": "Ajouter votre CV",
        "download": "Téléchargement...",
        "editCv": "Modifier votre CV",
        "errorServer": "Une erreur est survenue, veuillez réessayer ultérieurement.",
        "errorUpload": "Une erreur est survenue lors du chargement de votre fichier.",
        "errorFileMarvin": "Le CV que vous avez ajouté a causé une erreur lors de votre précédente candidature, merci de postuler avec un autre CV.",
        "msgMaxsize": "Veuillez vérifier le poids de votre fichier.",
        "msgExtension": "Veuillez vérifier le format de votre fichier.",
        "msgRequiredCv": "Veuillez ajouter votre CV.",
        "useCv": "Utiliser un nouveau CV"
    };
    private inputElement: HTMLInputElement;
    private file: File;
    private isMultiCv: HTMLSelectElement;
    private isRequired: boolean;
    private label: HTMLElement;
    private service: CvUploaderService;
    private progressComponent: any;
    private validationMessageSpan: HTMLSpanElement;
    private url: string;
    private uploaderType: string;
    private uploaderApp: string;
    private uploaderKey: string;
    private maxsize: number;
    private extension: string;

    constructor(
        private props: CvUploaderProps,
        element: HTMLInputElement
    ) {
        super(props, element);

        this.isRequired = this.props.required === "False" ? false : true;

        if(this.props.uploaderType) {
            this.uploaderType = this.props.uploaderType;
        }
        if(this.props.uploaderApp) {
            this.uploaderApp = this.props.uploaderApp
        }
        if(this.props.uploaderKey) {
            this.uploaderKey = this.props.uploaderKey;
        }
        if(this.props.maxsize) {
            this.maxsize = this.props.maxsize;
        }
        if(this.props.extension) {
            this.extension = this.props.extension;
        }

        if (this.props.url) {
            this.url = this.props.url;
            this.service = new CvUploaderService(this.url);
        } 
    }

    mounted(): void {
        this.progressComponent = getSingleInstanceByName('SimpleProgress')

        this.inputElement = this.element as HTMLInputElement;
        this.file = this.inputElement.files[0];

        // TODO Ugly, need a proper way to retrieve linked message element
        const parent: HTMLElement = this.inputElement.parentNode.parentNode as HTMLElement;
        this.validationMessageSpan = parent.querySelector('span[data-valmsg-for="rjupload"]');
            
        this.label = parent.querySelector(".input__label");

        // Update the labels
        if (this.props.msg) this.setMsg();
        if (this.props.button) this.setButton();
        
        if (this.label.classList.contains('with-icon')) {
            const text = document.createTextNode(this.labels.addCv)
            this.label.appendChild(text)
        } else {
            this.label.innerHTML = this.labels.addCv
        }

        this.validForm();

        this.inputElement.onchange = () => this.onChange();
        
        PubSub.subscribe('add-list-cv', () =>  this.addListCV());
        
        initialiseComponents();
    }

    private onChange (): void {
        this.file = this.inputElement.files[0];  
        const fileName = (this.file.name.length > 27) ? this.file.name.substring(0, 23) + "..." : this.file.name;

        if (this.isMultiCv && this.validFile()) {
            const optgroup: HTMLOptGroupElement = document.createElement("optgroup"),
                option: HTMLOptionElement = document.createElement('option');

            optgroup.appendChild(option);
            option.value = "0";
            option.innerText = fileName;
            this.isMultiCv.appendChild(optgroup);
            this.isMultiCv.value = "0";
        }
        
        if (this.file && this.validFile()) {
            this.upload(fileName, this.validationMessageSpan);
        } else {
            this.label.innerHTML =  this.isMultiCv ? this.labels.useCv : this.labels.addCv;
            this.showErrors(this.inputElement.validationMessage);
        }

        // We must reset value when all is done because onChange won't fire another event otherwise
        this.inputElement.value = null
    }

    setUrl(url: string):void {
        this.url = url;
        this.service = new CvUploaderService(this.url);
    }
    setType(type: string):void {
        this.uploaderType = type;
    }
    setApp(app: string):void {
        this.uploaderApp = app;
    }
    setKey(key:string):void {
        this.uploaderKey = key;
    }
    setMaxsize(size:number):void {
        this.maxsize = size;
    }
    setExtension(extension: string):void {
        this.extension = extension;
    }

    addListCV(): void {
        this.isMultiCv = <HTMLSelectElement>document.getElementById("Answer_FileId");
        this.inputElement.parentElement.classList.add("has-list-cv");
        this.label.innerHTML = this.labels.useCv;
        initialiseComponents();
    }

    /**
     * show valid icon
     * @param validationMessage
     */
    showValidIcon (validationMessage: Element): void {
        const icon = validationMessage.querySelector('.icon')
        if (icon) {
            icon.classList.remove('hide')
        }
    }

    setMsg(): void {
        if (this.props.msg.required) {
            this.labels.msgRequiredCv = this.props.msg.required;
        }
        if (this.props.msg.maxsize) {
            this.labels.msgMaxsize = this.props.msg.maxsize;
        }
        if (this.props.msg.extension) {
            this.labels.msgExtension = this.props.msg.extension;
        }
    }

    setButton(): void {
        if (this.props.button.addCv) {
            this.labels.addCv = this.props.button.addCv;
        }
        if (this.props.button.download) {
            this.labels.download = this.props.button.download;
        }
        if (this.props.button.editCv) {
            this.labels.editCv = this.props.button.editCv;
        }
        if (this.props.button.useCv) {
            this.labels.useCv = this.props.button.useCv;
        }
    }

    upload(fileName:string, validationMessage:HTMLElement): void {
        if (this.file) {
            if(this.progressComponent) {
                 this.progressComponent.start();
            }
            const inputkey = document.querySelector<HTMLInputElement>("[name=UploaderKey]");
            const formData = new FormData();
            //formData.append("UploaderKey", this.uploaderKey);
            formData.append("UploaderType", this.uploaderType);
            formData.append("UploaderApp", this.uploaderApp);
            formData.append("File", this.file);

            this.service.post(formData, (response: {fileHash:string}) => {
                if (this.progressComponent) {
                    this.progressComponent.stop();
                }

                inputkey.value = response.fileHash;
                this.label.innerHTML = this.labels.editCv;
               
                initialiseComponents();

                const element: HTMLSpanElement = document.createElement("span");
                element.textContent = fileName;
                element.className = 'filename'

                this.inputElement.classList.remove("input-validation-error");

                validationMessage.classList.remove("field-validation-error");
                validationMessage.classList.add("field-validation-valid");

                const previousFilename = validationMessage.querySelector('.filename')

                if (previousFilename) {
                    validationMessage.removeChild(previousFilename);
                }
                validationMessage.innerHTML = "";
                validationMessage.appendChild(element);
                this.showValidIcon(validationMessage);
                this.element.dispatchEvent(new CustomEvent("load", { detail: {
                    fileName: (<File>formData.get('File')).name,
                    uploadKey: inputkey.value,
                    uploadType: formData.get('UploaderType')
                }, bubbles: true, cancelable: true }));
                PubSub.publish("upload-cv-done");
            });

            this.service.setErrorHandler((response: {message:string, trackingsClick: any}) => {
                this.label.innerHTML = this.labels.editCv;
                let message: string = this.labels.errorFileMarvin;
                if(response?.message) {
                    message = response.message;
                }
                if(response?.trackingsClick) {
                    window.dataLayer.push(response.trackingsClick);
                }

                this.showErrors(response.message);

                PubSub.publish("upload-cv-error");
            });
        }
    }

    /**
     * Prevent submit if file is not valid
     */
    validForm(): void {
        const form: HTMLFormElement = this.inputElement.closest("form");
        if (form) {
            form.onsubmit = (event: Event) => {
                if (!this.isValid()) event.preventDefault();
            }
        }
    }

    /**
     * Check input validity and display error messages accordingly
     */
    isValid(): boolean {
        let valid = true;

        this.inputElement.setCustomValidity("");

        if (this.isMultiCv) {
            if (this.isRequired && this.isMultiCv.value === "") {   
                this.inputElement.setCustomValidity(this.labels.msgRequiredCv);
                valid = false;
            }
        } else {
            if (this.isRequired && !this.file) {   
                this.inputElement.setCustomValidity(this.labels.msgRequiredCv);
                valid = false;
            }
            valid = this.validFile() && this.validationMessageSpan.classList.contains("field-validation-valid") && valid;
                if (!valid) {
                    this.showErrors("Veuillez ajouter votre CV.");
                    return valid;
                }
        }            

        if (!valid) {
            this.showErrors(this.inputElement.validationMessage);
        }

        return valid
    }

    validFile(): boolean {
        let valid = true;

        if (!this.validFileSize() || !this.validFileType()){
            valid = false;
        }

        if (!valid) {
            this.inputElement.value = null;
        }
        
        return valid;
    }

    validFileSize(): boolean {
        if (this.file) {
            if (this.maxsize && (this.file.size > this.maxsize)) {
                this.inputElement.setCustomValidity(this.labels.msgMaxsize);
                return false;
            }
        }
        return true;
    }

    validFileType(): boolean {
        if (this.extension) {
            if (!this.checkFileType(this.file, this.extension)) {
                this.inputElement.setCustomValidity(this.labels.msgExtension);
                return false;
            }
        }

        return true;
    }
    
    checkFileType(file: File, fileTypes: string): RegExpMatchArray {
        fileTypes = (typeof fileTypes === "string") ? fileTypes.replace( /,/g, "|" ) : "png|jpe?g|gif";
        return file?.name.match(new RegExp( "\\.(" + fileTypes + ")$", "i" ));
    }

    showErrors(msg :string): void {
        const parent: HTMLElement = this.inputElement.parentNode.parentNode as HTMLElement,
            validationMessage: HTMLElement = parent.querySelector('span[data-valmsg-for="rjupload"]') as HTMLElement;

        this.inputElement.classList.add("input-validation-error");
        validationMessage.classList.remove("field-validation-valid");
        validationMessage.classList.add("field-validation-error");
        validationMessage.innerText = msg;
        PubSub.publish("upload-cv-error.errormodal", msg);
    }
}